import { useLayoutEffect, useRef, useState } from 'react';

export const useCatalogLayout = (count) => {
  const ref = useRef(null);
  const [columns, setColumns] = useState(3);
  useLayoutEffect(() => {
    const parent = ref.current?.parentElement;
    if (!parent) return;
    const resize = () => {
      const width = parent.clientWidth;
      setColumns(Math.max(2, Math.min(8, Math.floor(width / 160))));
    };
    const observer = new ResizeObserver(resize);
    observer.observe(parent);
    resize();
    return () => observer.disconnect();
  }, [count]);
  return { ref, compact: false, style: {
    gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
    gridAutoRows: '112px',
  } };
};